<template>
  <div
    id="app">

    <TheHeader
      :window-width="$root.window.width"
      :desktop-leading-items="[
        { text: 'Home', href: '/appstore' },
        { text: 'About Appstore', href: 'https://www.domo.com/automation/about-appstore' },
        { text: 'Build on Domo', href: 'https://www.domo.com/platform/build' },
        { text: 'Help', href: 'https://www.domo.com/help-center' },
      ]"
      :mobile-items="[
        { text: 'Home', href: '/appstore' },
        { text: 'About Appstore', href: 'https://www.domo.com/automation/about-appstore' },
        { text: 'Build on Domo', href: 'https://www.domo.com/platform/build' },
        { text: 'Help', href: 'https://www.domo.com/help-center' },
      ]"
    />

    <keep-alive
      :exclude="[
        'SearchView',
        'AwsSearchView',
      ]">
      <router-view
        :apps-data="$route.name === 'search' ? $root.allAppsData : null"
        :filters-data="$route.name === 'search' ? $root.filtersData : null"
        :detail-data="$root.detailData"
        :loading-detail-data="$root.loadingDetailData"
        :optimistic-detail-data="$root.optimisticDetailData"
        :loading-apps="$root.loadingApps"
        :cached-sort-value="$root.cachedSortValue"
        :detail-view-back-route="$root.detailViewBackRoute"
      />
    </keep-alive>

    <TheFooter
      v-show="!$route.meta.isFooterHidden"
      :items="$root.footerItems"
      :socials="$root.socials"
      :privacies="$root.privacies"
    />

  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue';
import TheFooter from '@/components/TheFooter.vue';

export default {
  name: 'App',

  components: {
    TheHeader,
    TheFooter,
  },

  metaInfo() {
    return {
      title: 'Domo Appstore: Connect, Transform, and Visualize',
      titleTemplate: '%s | Domo',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Domo\'s Appstore allows users to connect, analyze, and visualize all their crucial business data with thousands of pre-built apps and API integrations.',
        },
      ],
    };
  },
};
</script>

<style src="@/styles/index.scss" lang="scss"></style>
<style src="@/assets/icon-fonts/domo-com/style.css" lang="css"></style>
<style src="@/assets/icon-fonts/domo-icons/style.css" lang="css"></style>
<style src="@/assets/icon-fonts/social/style.css" lang="css"></style>

<style lang="scss" scoped>
@import '@/styles/_variables';

#app {
  min-height: 100vh;
  padding-top: 60px;
}
</style>
